import {axios} from '../utils/axios'

export function getnews(data){
  return axios({
    url: "/getThemListByDict",
    method: 'get',
    params: data,
  })
}
export function getmsg(data){
  return axios({
    url: "/msb/getUserInfo",
    method: 'get',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/news.js